import { createContext } from 'react';

export const InsideAppProviderContext: import('react').Context<boolean> = createContext(false);
